<template>
  <v-container>
    <v-row>
      <v-col
        class="text-center d-flex flex-column align-start ml-4 pl-4 ml-md-16 pl-md-16"
        md="12"
        sm="12"
      >
        <v-icon style="font-size: 180px" color="secondary" class="mt-16 mb-8"
          >mdi-check-circle-outline</v-icon
        >

        <h1
          class="text-center mb-12 font-weight-light text-h4 text-md-h3"
          style="color: #fed400; font-family: inherit !important"
        >
          Congratulations!
        </h1>

        <p
          style="color: white; font-family: inherit !important"
          class="text-left pa-0 text-h6 text-md-h5"
        >
          Thank you for registering to join Timeless Courier platform you can
          <br />
          now enjoy all Timeless courier Platform Features
        </p>
        <br />
        <v-btn
          rounded
          to="/dashboard"
          x-large
          color="primary"
          class="mt-5"
          style="color: #fed400; border: 1px solid white !important;"
          >Explore Dashboard</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DashboardFinish"
};
</script>

<style scoped></style>
